import {useNuxtApp} from "nuxt/app"
import {defineStore} from 'pinia'
import {ref} from 'vue'
import {useNotification} from "@/composables/useNotification"

export const useCmsNavItemsStore = defineStore('cmsNavItems', () => {
    const cmsNavItems = ref([])
    const cmsNavItemsLoading = ref(false)

    function storeCmsNavItems(response) {
        cmsNavItems.value = response.data?.value?.entries
    }

    function fetchCmsNavItems() {
        cmsNavItemsLoading.value = true
        useAsyncGql('navigation')
            .then(storeCmsNavItems)
            .catch(handleRequestError)
            .finally(() => {
                cmsNavItemsLoading.value = false
            })
    }

    function handleRequestError(error) {
        const notification = useNotification()
        const app = useNuxtApp()
        if (error && error.response && error.response.status === 422) {
            notification.error(app.$i18n.t('invalidRequestData') + '\n' + error.response._data.message)
        } else {
            if (error && error.response?._data.message) {
                notification.error(app.$i18n.t('generalRequestError') + '\n' + error.response._data.message)
            } else if ( error && error.response?._data) {
                notification.error(app.$i18n.t('generalRequestError') + '\n' + error.response._data)
            } else {
                notification.error(app.$i18n.t('generalRequestError'))
            }
        }
    }

    return {
        cmsNavItems,
        cmsNavItemsLoading,
        fetchCmsNavItems
    }
})
